import React from 'react';
import {Field, FieldArray, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {AbstractReactComponent, Icon} from 'components/shared';
import { FormattedMessage } from 'react-intl';
import { globalMessages } from 'components/shared/lang/messages';
import { templateMessages } from './templateMessages';
import { getIntl } from 'components/shared/lang/intlInstance';
import {Accordion, Card, Form, Modal} from 'react-bootstrap';
import {Button} from '../ui';
import {indexById} from 'stores/app/utils';
import {decorateFormField, submitForm} from 'components/form/FormUtils';

import './FundSettingsForm.scss';
import NoFocusButton from '../shared/button/NoFocusButton';
import FormInput from '../shared/form/FormInput';

import './FundTemplateSettingsForm.scss';
import {JAVA_ATTR_CLASS} from '../../constants';
import FormInputField from "../shared/form/FormInputField";
import { convertToOldDescItem, convertToOldTemplate } from './node-edit/templates/conversionUtils';
import { getValue } from './node-edit/templates/utils';

class FundTemplateSettingsForm extends AbstractReactComponent {
    /**
     * Validace formuláře.
     */
    static validate = (values, props) => {
        const errors = {};
        const names = {};
        let i = 0;
        values.templates.forEach(template => {
            const name = template.name.trim().toLowerCase();
            if (names[name]) {
                errors._error = getIntl().formatMessage(templateMessages.fundTemplateErrorDuplicate, { 0: template.name });
            } else {
                names[name] = true;
            }
            i++;
        });
        return errors;
    };

    state = {
        open: {},
        edit: {},
    };

    submitReduxForm = (values, dispatch) =>
        submitForm(FundTemplateSettingsForm.validate, values, this.props, this.props.onSubmitForm, dispatch);

    renderItems = formData => {
        const {descItemTypes} = this.props;

        const results = [];
        let i = 0;
        Object.keys(formData).forEach(key => {
            let items = formData[key];
            if (items.length === 0) {
                return;
            }

            if(!Array.isArray(items)) { // new template is loaded as object
                items = [convertToOldDescItem(items)];
            }

            // old templates use key from their definition as itemTypeId
            // new templates have it saved in every descItem
            const itemTypeId = items[0]?.itemTypeId || key;
            const itemType = descItemTypes.items[indexById(descItemTypes.items, parseInt(itemTypeId))];

            items?.forEach(item => {
                results.push(this.renderItem(`${itemTypeId}_${i++}`, itemType, item));
            });
        });

        return results;
    };

    renderItem = (key, itemType, item) => {
        let spec;
        if (item.descItemSpecId) {
            const itemSpec = itemType.descItemSpecs[indexById(itemType.descItemSpecs, item.descItemSpecId)];
            let csl = 'item-spec';
            if (item[JAVA_ATTR_CLASS] !== '.ArrItemEnumVO') {
                csl += ' item-noenum';
            }
            spec = <span className={csl}>{itemSpec?.name || "unknown"}</span>;
        }

        let val;

        switch (item[JAVA_ATTR_CLASS]) {
            case '.ArrItemTextVO':
            case '.ArrItemStringVO':
            case '.ArrItemFormattedTextVO':
                val = item.value && item.value.length > 100 ? item.value.substring(0, 100).trim() + '...' : item.value;
                break;
            case '.ArrItemRecordRefVO':
            case '.ArrItemFileRefVO':
                val = item.strValue || item.value;
                break;
            default:
                val = item.value;
        }

        if (item.undefined) {
            val = <span className="item-undefined">{<FormattedMessage {...templateMessages.fundTemplateUndefined} />}</span>;
        }

        return (
            <div key={key}>
                <span className="item-type">{itemType.shortcut}</span>
                {spec}
                {val}
            </div>
        );
    };

    render() {
        const {
            handleSubmit,
            onClose,
            error,
        } = this.props;
        const {edit, open} = this.state;

        return (
            <Form className="templates-form" onSubmit={handleSubmit(this.submitReduxForm)}>
                {error && <div className="form-error">{error}</div>}
                <Modal.Body className="template-items">
                    <FieldArray
                        name={'templates'}
                        component={({fields, meta}) => {
                            if (fields.length === 0) {
                                return <div>{<FormattedMessage {...templateMessages.fundTemplateEmpty} />}</div>
                            }

                            return fields.map((item, index, fields) => {
                                const header = (
                                    <div
                                        onClick={e => {
                                            if (edit[index]) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }
                                        }}
                                        className="pull-left template-name"
                                    >
                                        {edit[index] ? (
                                                <Field
                                                    name={`${item}.name`}
                                                    type="text"
                                                    component={FormInputField}
                                                    label={false}
                                                />
                                        ) : (
                                            fields.get(index)?.name
                                        )}
                                    </div>
                                );
                                return (
                                    <Accordion
                                        activeKey={index}
                                        onClick={() => {
                                            open[index] = !open[index];
                                            this.setState({open});
                                        }}
                                        accordion
                                        style={{margin: '2px'}}
                                    >
                                        <Card>
                                            <Card.Header>
                                                <div className="clearfix">
                                                    {header}
                                                    <div className="pull-right">
                                                        <NoFocusButton
                                                            className={'btn-action'}
                                                            onClick={e => {
                                                                const newEdit = {};
                                                                newEdit[index] = !edit[index];
                                                                this.setState({edit: newEdit});
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Icon glyph="fa-edit" />
                                                        </NoFocusButton>
                                                        <NoFocusButton
                                                            className={'btn-action'}
                                                            onClick={e => {
                                                                this.setState({edit: {}});
                                                                fields.remove(index);
                                                                e.stopPropagation();
                                                            }}
                                                        >
                                                            <Icon glyph="fa-trash" />
                                                        </NoFocusButton>
                                                    </div>
                                                </div>
                                            </Card.Header>
                                            {open[index] && <div
                                                style={{padding: '16px'}}
                                                onClick={e => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }}
                                            >
                                                {this.renderItems(fields.get(index).formData)}
                                            </div>}
                                        </Card>
                                    </Accordion>
                                );
                            });
                        }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button type="submit" variant="outline-secondary">
                        {<FormattedMessage {...templateMessages.visiblePolicyActionSave} />}
                    </Button>
                    <Button variant="link" onClick={onClose}>
                        {<FormattedMessage {...globalMessages.cancel} />}
                    </Button>
                </Modal.Footer>
            </Form>
        );
    }
}

function mapState(state) {
    const {refTables} = state;
    return {
        descItemTypes: refTables.descItemTypes,
    };
}

const connector = connect(mapState);

export default reduxForm({
    form: 'fundTemplateSettingsForm',
})(connector(FundTemplateSettingsForm));
